import React from 'react'

import { Field } from 'common/fields/entities/field'
import FieldSearch from 'common/fields/linking/components/FieldSearch'
import { usePickerStyle } from 'common/fields/linking/hooks/usePickerStyle'

type ConditionField = Pick<Field, 'type'> & { name: string; segment_type?: string }

interface FilterFieldsSearchProps {
  fields: Field[]
  onSelect: (field: ConditionField) => void
  isBuilder: boolean
}

const FilterFieldsSearch = ({ fields, onSelect, isBuilder }: FilterFieldsSearchProps) => {
  const handleFieldSelect = React.useCallback(
    (fieldId: string) => {
      const field = fields.find((field) => field.id === fieldId)
      if (field) {
        onSelect({ name: field.id, type: field.type, segment_type: field.segmentType })
      }
    },
    [onSelect, fields],
  )
  const { hidePickerCategories, pickerWidth } = usePickerStyle(fields)
  const pickerStyle = { width: pickerWidth }

  return (
    <div style={pickerStyle}>
      <FieldSearch
        autofocus
        fields={fields}
        onSelect={handleFieldSelect}
        hideCategories={hidePickerCategories}
        trackFieldSelection={isBuilder}
      />
    </div>
  )
}

export default FilterFieldsSearch
